export default __webpack_public_path__ + "static/nav-logo-4f4afa16b2c207468b15bd553994d1d9.jpg";